import React from 'react';
import { LeadForm } from '../../components/LeadForm';
export function FreeTrialHeroForm() {
  return <div id="hero-form" className="bg-paper p-8 rounded-2xl shadow-2xl border border-subtle-gray relative scroll-mt-24" data-id="element-1515">
      <div className="absolute -top-4 left-1/2 -translate-x-1/2 bg-storm-red text-white px-6 py-2 rounded-full font-bold uppercase tracking-wide whitespace-nowrap shadow-lg text-sm" data-id="element-1516">
        Find the Right Class or Program
      </div>
      <div className="mt-4" data-id="element-1517">
        <p className="text-center text-gray-warm mb-4 text-sm" data-id="element-1518">
          Ages 3+ · Beginners welcome · No experience needed
        </p>
        <LeadForm buttonText="Check Availability" showChildAge helperText="We'll help you choose the best starting class or program before your first visit." data-id="element-1519" />
      </div>
    </div>;
}